module.exports = __webpack_public_path__ + "static/media/skeleton.72b37dae.dae";